import { LoadablePaint } from '@confluence/loadable';

export const LazyHeaderAndFooterPage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-HeaderAndFooterContainer" */ '../src/HeaderAndFooter/HeaderAndFooterPage'
			)
		).HeaderAndFooterPage,
});
